import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import { 
  NotificationType, 
  NotificationTypeDDL,
  SendTypeDDL,
  AssessmentDto,
  SendTypes,
  UserNotification,
  SmsNotification
} from "@/views/sidebar/notification/notification.type";
import NotificationService from "@/views/sidebar/notification/notification.service";

@Module({ namespaced: true })
class Notification extends VuexModule {
  notificationTypes: NotificationType[] = [];
  notificationTypeDDL: NotificationTypeDDL[] = [];
  selectedNotificationTypeDDL = new NotificationTypeDDL();
  sendTypeDDL: SendTypeDDL[] = [
    { text: "Send to phone", value: SendTypes.PHONE },
    { text: "Send to watch ", value: SendTypes.WATCH },
  ];
  selectedSendTypeDDL: SendTypeDDL = { text: "Send to phone", value: 0 };

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchNotificationTypes(clientId: number) {
    const notificationTypes = await NotificationService.getNotificationTypes(clientId);
    this.context.commit("updateField", {
      path: "notificationTypes",
      value: notificationTypes
    });
    const notificationTypeDDL = notificationTypes.map((notificationType: any) => {
      return {
        text: notificationType.name,
        value: notificationType.row
      }
    });
    notificationTypeDDL.unshift({
      text: "Please select notification type",
      value: 0
    });
    this.context.commit("updateField", {
      path: "notificationTypeDDL",
      value: notificationTypeDDL
    });
    if (notificationTypeDDL.length > 0) {
      this.context.commit("updateField", {
        path: "selectedNotificationTypeDDL",
        value: notificationTypeDDL[0]
      });
    }
  }

  @Action({ rawError: true })
  async createAssessment(assessmentDto: AssessmentDto) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await NotificationService.createAssessment(assessmentDto);
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  async sendNotification(userNotification: UserNotification) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await NotificationService.sendNotification(userNotification);
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }

  @Action({ rawError: true })
  async sendSmsNotification(smsNotification: SmsNotification) {
    try {
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: null
      }, { root: true });
      await NotificationService.sendSmsNotification(smsNotification);
    } catch (e: any) {
      const errorMessage = e.response.data.message;
      this.context.commit("Base/updateField", {
        path: "errorMessage",
        value: errorMessage
      }, { root: true });
    }
  }


  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Notification.getters = { getField };
Notification.mutations = { updateField };

export default Notification;